import React from 'react';

import { Theme } from '@emotion/react';
import { SxProps, TableCell, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { IStaffTravel } from '../../../../types/staff-travel.type';

const sxTableHead: SxProps<Theme> = { '& td': { textAlign: 'center' } };

interface IProps {
  travel: IStaffTravel;
}

const StaffTravelListItem = React.memo(({ travel }: IProps) => {
  const { t } = useTranslation();

  return (
    <TableRow sx={sxTableHead}>
      <TableCell>{t(`school.${travel.previousSchool}`)}</TableCell>
      <TableCell>{t(`school.${travel.school}`)}</TableCell>
      <TableCell>{travel.schoolYear}</TableCell>
      <TableCell>{travel.schoolLevel}</TableCell>
      <TableCell sx={{ fontWeight: 'bold' }}>{travel.total}</TableCell>
    </TableRow>
  );
});

export default StaffTravelListItem;
